import styled from '@emotion/styled';

export const Iframe = styled.iframe`
  height: 100%;
  border: none;
`;
